import { gql } from '@apollo/client';
import client from 'apollo/apollo-client';

export async function pumpsConfigure(variables) {
  return await new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: CONFIGURE_WATERPUMPS,
        variables,
        skip: skip(variables),
        refetchQueries: ['WaterPumpsByCustomer'],
      })
      .then(
        ({
          data: {
            WaterPumpsConfigure: { error, data, message },
          },
          loading,
        }) => {
          resolve({ data, loading, error, message });
        },
      )
      .catch((error) => {
        reject(new Error({ error: true, message: error.message, data: {} }));
      });
  });
}

function skip(variables) {
  let skip = true;
  let { name, location, deviceId } = variables;
  skip = ![name, location, deviceId].every((v) => v);
  return skip;
}

const CONFIGURE_WATERPUMPS = gql`
  mutation WaterPumpsConfigure($_id: ID, $name: String!, $location: String!, $deviceId: ID!) {
    WaterPumpsConfigure(_id: $_id, name: $name, location: $location, deviceId: $deviceId) {
      error
      data {
        _id
        name
        location
        deviceId
      }
      message
    }
  }
`;
